import UserProductsSubMenusLinks from "@/components/menu/sub-menus/products/UserProductsSubMenusLinks.vue";
import ProductList from "@/components/products/WineListComponent.vue";
export default {
  name: "UserProductList",
  components: {
    UserProductsSubMenusLinks: UserProductsSubMenusLinks,
    ProductList: ProductList
  },
  props: {
    loggedUserData: Object
  },
  data: function data(_this) {
    return {
      selectedTab: null,
      tabs: {
        wines: "wines",
        spirits: "spirits"
      }
    };
  },
  created: function created() {
    this.selectedTab = this.$route.query.tab || this.tabs.wines;
  },
  methods: {
    tabChanged: function tabChanged(tab) {
      this.selectedTab = tab;
    }
  }
};